export const RESPONSE_TIMEOUT = 5 * 1000;
